import { createAction } from "redux-actions";
import { SET_LOADING } from "./Loader.constants";

export const setLoading = createAction<boolean>(SET_LOADING);
